import CacheStorage from "../../../service/storage/CacheStorage";
import StorageKeys from "../../../const/StorageKeys";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { navigate } from "../../../service/navigation/Navigation";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import ShowToast from "../../../widget/common/ui/Toast";
import { GuestBranchInfoModel } from "../../../model/home_guest_user/GuestBranchInfoModel";

const HomeGuestUserProvider = new (class HomeGuestUserProvider {
  navigate = (url: string) => {
    navigate(url);
  };

  getBranchDetail = async (
    bId: string = ""
  ): Promise<GuestBranchInfoModel | null> => {
    ApiUrls.init();

    const barnchId: string = UtilityHelper.isNotEmpty(bId)
      ? bId
      : CacheStorage.getValue(StorageKeys.branch_id);

    const url: string = `${ApiUrls.baseUrl}search/get_guest_branch_info`;
    const body: any = {
      branch_id: barnchId,
    };

    const response: any = await ApiService.postApi(url, body);
    if (response != null) {
      if (response["success"] === "1") {
        const branchInfoModel: GuestBranchInfoModel = response;
        return branchInfoModel;
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default HomeGuestUserProvider;
